import React from "react";

import styles from "./ListCard.module.scss";
import { OrderProps } from "../../types/order";
import { useAppDispatch } from "../../app/hooks";
import { updateIsImgModalOpen } from "../../features/settings/settingsSlice";

type Props = {
  order: OrderProps;
};

const ListCard = ({ order }: Props) => {
  const dispatch = useAppDispatch();

  const handleShowImgModal = (src: string) => {
    dispatch(updateIsImgModalOpen(src));
  };

  return (
    <div className={styles.ListCard}>
      <h5 className="text-primary-1 text-lg font-semibold">
        Order ID : {order.id}
      </h5>

      <div className="flex gap-4 mt-5">
        <img
          className="w-[100px] h-[100px] bg-white"
          src={`${order.image}?order=${order.id}`}
          alt=""
          // onClick={() => handleShowImgModal(order.image)}
        />

        <div className="flex flex-col gap-3">
          <p className="text-primary-1 text-sm font-semibold">
            Party Name : {order.party.firm_name}
          </p>
          <p className="text-primary-1 text-sm font-semibold">
            Item Name : {order?.name ? `${order?.name} - ` : ""}{order?.item?.name}
            {order?.inch > 1 && ` ${order?.inch} Inch`}
          </p>
          <p className="text-primary-1 text-sm font-semibold">
            Process Name : {order.process.name}
          </p>
          <p className="text-primary-1 text-sm font-semibold">
            Quantity : {order.qty}
          </p>
          {order.deliveries && order.deliveries.length > 0 && (
            <p className="text-primary-1 text-sm font-semibold">
              Delivered Qty : {order.deliveries.reduce((sum, d) => sum + d.qty, 0)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
export default ListCard;
